var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useEffect, useState } from 'react';
import useLazyFetch from './useLazyFetch';
/**
 * Hook that fetches immediately
 * @param {string} url - url to fetch
 * @param {FetchRequest<ReqBody>} request - request body
 * @param {FetchOptions<ReqBody>} options - request options (callbacks, timeout, retry config, etc)
 */
export default function useFetch(url, request, options) {
    if (options === void 0) { options = {}; }
    var _a = useState(false), called = _a[0], setCalled = _a[1];
    var _b = useState(false), responded = _b[0], setResponded = _b[1];
    var obj = useLazyFetch(url, request, __assign(__assign({}, options), { onFinal: function () {
            if (options.onFinal)
                options.onFinal();
            setResponded(true);
        } }));
    useEffect(function () {
        if (called)
            return;
        obj.makeRequest();
        setCalled(true);
    }, [called, obj]);
    return {
        data: obj.data,
        error: obj.error,
        loading: !responded || obj.loading,
        makeRequest: obj.makeRequest,
    };
}
